import { useEffect } from "react";
import cn from "classnames";

import InputForFormUniversal from "../../../../components/GeneralComponents/componentsForFormUniversal/inputForFormUniversal/InputForFormUniversal";

import styles from "./PatternField.module.css";

function PatterField({ item, register, errors, setValue }) {
  useEffect(() => {
    setValue(item.key, item.title);
  }, []);

  return (
    <>
      <InputForFormUniversal
        mode={item.mode || "edit"}
        register={register}
        inputProps={item}
        errors={errors}
        setValue={setValue}
        externalStyles={styles}
      />
      {item.children && (
        <div className={cn(styles["field-child__container"], { [styles['child__container-style']]: item.childContainerStyle })}>
          {item.children.map((item, i) =>
            typeof item === "string" ? (
              <p className={styles["field-child"]} key={i}>
                {item}
              </p>
            ) : (
              <PatterField
                key={i}
                item={item}
                register={register}
                errors={errors}
                setValue={setValue}
              />
            )
          )}
        </div>
      )}
    </>
  );
}

export default PatterField;
